
import { createStore } from 'vuex'

const store = createStore({})

// Load store modules dynamically.
const moduless = import.meta.glob('@/store/modules/*.js', { eager: true })

for (const path in moduless) {
  const moduleName = path.split('/').pop().replace('.js', '')
  const mod = moduless[path]
  if (mod?.default) {
    store.registerModule(moduleName, mod.default)
  }
}

export default store
